import { render, staticRenderFns } from "./NotificationTemplateSettings.vue?vue&type=template&id=72b02988&"
import script from "./NotificationTemplateSettings.vue?vue&type=script&lang=js&"
export * from "./NotificationTemplateSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports